/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { CSSObject } from "styled-components";
import { Table, theme } from "@nordcloud/gnui";

export const StyledTh = styled(Table.th)`
  font-size: ${theme.fontSizes.sm} !important;
  letter-spacing: normal;
  color: ${theme.color.text.text02};
  font-weight: ${theme.fontWeights.medium};
  vertical-align: middle;
  cursor: pointer;
`;

export const StyledTd = styled(Table.td)`
  vertical-align: middle;
`;

export const StyledRow = styled(Table.tr)`
  &.interactive {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
`;

type MetaCss = {
  css: CSSObject;
};

export const internalTheme = {
  columns: {
    small: "10rem",
    medium: "15rem",
    large: "20rem",
  },
};
export const SmallIconColumn: MetaCss = {
  css: {
    minWidth: "2rem",
    maxWidth: "2rem",
    padding: 0,
  },
};

export const MediumIconColumn: MetaCss = {
  css: {
    minWidth: "3rem",
    maxWidth: "3rem",
    padding: 0,
  },
};

export const LargeIconColumn: MetaCss = {
  css: {
    minWidth: "4rem",
    maxWidth: "4rem",
    padding: 0,
  },
};

export const ActionsColumn: MetaCss = {
  css: {
    minWidth: "5rem",
    maxWidth: "5rem",
    padding: theme.spacing.spacing03,
  },
};

export const TinyColumn: MetaCss = {
  css: {
    maxWidth: "5rem",
    minWidth: "5rem",
    padding: theme.spacing.spacing03,
  },
};

export const SmallColumn: MetaCss = {
  css: {
    maxWidth: "10rem",
    minWidth: "10rem",
    padding: theme.spacing.spacing03,
  },
};

export const MediumColumn: MetaCss = {
  css: {
    maxWidth: "15rem",
    minWidth: "15rem",
    padding: theme.spacing.spacing03,
  },
};

export const LargeColumn: MetaCss = {
  css: {
    maxWidth: "20rem",
    minWidth: "20rem",
    padding: theme.spacing.spacing03,
  },
};

export const FlexColumnSmall: MetaCss = {
  css: {
    width: "20%",
    padding: theme.spacing.spacing03,
  },
};

export const FlexColumn: MetaCss = {
  css: {
    width: "40%",
    padding: theme.spacing.spacing03,
  },
};

export const FlexColumnLarge: MetaCss = {
  css: {
    width: "60%",
    padding: theme.spacing.spacing03,
  },
};

export const FlexColumnMax: MetaCss = {
  css: {
    width: "100%",
    padding: theme.spacing.spacing03,
  },
};

export const GreyText = styled.span`
  color: ${theme.color.text.text03};
`;

export const ErrorText = styled.span`
  color: ${theme.color.text.error};
`;

export const TableScrollContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;
